(function (angular, app) {
   "use strict";

   angular.module(app.modules.handicap.name)
      .factory(app.modules.handicap.services.handicaps, HandicapFactory);

   HandicapFactory.$inject = [app.modules.common.services.http
       , app.modules.common.constants.appsettings
       , app.modules.common.services.functions
   ];

   function HandicapFactory($http
       , ggSettings
       , ggFunctions
       ) {

      var search = {
         fetchHandicapClubsByMember: function (data) {
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.club.memberships;
            var qry = "?$filter=memberId eq " + data.memberId;
            if (data.isPrimary) {
               qr += " and isPrimary eq true"
            }
            var exp = "&$expand=club($select=id,name,isActive,type,address)";
            var ord = "";
            return $http.get(apipath + qry + exp + ord, {});
         }
         , fetchRevisionsByClubMembership: function (data) {
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.handicap.handicaps;
            var qry = "?$filter=membershipId eq " + data.membershipId;
            if (data.Active) {
                qry += " and isActive eq true"
            }
            var exp = "";
            var ord = "";
            return $http.get(apipath + qry + exp + ord, {});
         }
         , fetchScoresByRevisionId: function (data) {
            var apipath = ggSettings.gnapi.root + ggSettings.gnapi.handicap.scores;
            var qry = "(memberId="+data.memberId+",clubId="+data.clubId+",handicapId=" + data.revisionId + ",realTime=null)";
            var exp = "";
            var ord = "";

            return $http.get(apipath + qry, null);
         }
         
      }

      
      var service = {
         search: search
      }

      return service;
   }
}(angular, app));

